import axios from "axios";
import { showErrorToast, showSuccessToast } from "../components/Toast";
import { getUserType, resolveUid } from "../utilities/cookieUtils";
import { getEncodedTimestamp } from "../utilities/dateUtils";
import PKSOFT_URLS from "../utilities/Pk_api_Urls";

export const getUserId = (userInfo: any): string | null => {
  if (!userInfo) return null;

  // Check for user_id (proper user)
  if (userInfo?.user_id) return String(userInfo.user_id);
  if (userInfo?.userId) return String(userInfo.userId);

  // Check for guest_id (guest user)
  if (userInfo?.guest_id) return String(userInfo.guest_id);
  if (userInfo?.guestId) return String(userInfo.guestId);

  return null;
};

export const addToWishlistAPI = async (
  mappingCode: string
): Promise<{ success: boolean; count?: number }> => {
  try {
    const uid = resolveUid();
    const userType = getUserType();

    // Random users don't use API, handle locally in hook
    if (userType === "random") {
      return { success: true }; // Indicate to use local storage
    }

    if (!uid) {
      showErrorToast("Unable to identify user. Please log in again.");
      return { success: false };
    }

    const response = await axios.post(`${PKSOFT_URLS.CUSTOMER.WISHLIST}/add`, {
      uid: uid,
      mappingCode: String(mappingCode),
      
      d: getEncodedTimestamp(),
    });

    if (response.data.messageCode === 100 && response.data.status === 200) {
      const count = response.data?.data?.wishlistCount || 0;
      showSuccessToast(response.data.message);
      return { success: true, count };
    }
    showErrorToast(response.data.message);

    return { success: false };
  } catch (error: any) {
    console.error("Error adding to wishlist:", error);
    showErrorToast(
      error.response?.data?.message ||
        "Failed to add to wishlist. Please try again."
    );
    return { success: false };
  }
};

export const getWishlistAPI = async (): Promise<{ success: boolean; data?: any[]; }> => {
  try {
    const uid = resolveUid();
    const userType = getUserType();

    // For random users, wishlist is local-only (hook handles it)
    if (userType === "random") {
      return { success: true, data: [] };
    }

    if (!uid) {
      showErrorToast("Unable to identify user. Please log in again.");
      return { success: false, data: [] };
    }

    const url = `${
      PKSOFT_URLS.CUSTOMER.CHECKLIST
    }/${uid}/${getEncodedTimestamp()}`;
    const response = await axios.get(url);

    if (
      response.data?.messageCode === 100 &&
      (response.data.status === 200 ||
        typeof response.data.status === "undefined")
    ) {
      const items = response.data?.data || [];
      return { success: true, data: items };
    }

    showErrorToast(response.data?.message || "Failed to fetch wishlist");
    return { success: false, data: [] };
  } catch (error: any) {
    console.error("Error fetching wishlist:", error);
    showErrorToast(
      error.response?.data?.message ||
        "Failed to fetch wishlist. Please try again."
    );
    return { success: false, data: [] };
  }
};

export const removeFromWishlistAPI = async (
  mappingCode: string
  // userInfo: any
): Promise<{ success: boolean; count?: number }> => {
  try {
    const uid = resolveUid();
    const userType = getUserType();

    // Random users don't use API, handle locally in hook
    if (userType === "random") {
      return { success: true }; // Indicate to use local storage
    }

    if (!uid) {
      showErrorToast("Unable to identify user. Please log in again.");
      return { success: false };
    }

    const response = await axios.post(
      `${PKSOFT_URLS.CUSTOMER.WISHLIST}/remove`,
      {
        uid: uid,
        mappingCode: String(mappingCode),
        d: getEncodedTimestamp(),
      }
    );

    if (response.data.messageCode === 100 && response.data.status === 200) {
      const count = response.data?.data?.wishlistCount || 0;
      showSuccessToast(response.data.message);
      return { success: true, count };
    }

    showErrorToast(response.data.message);
    return { success: false };
  } catch (error: any) {
    console.error("Error removing from wishlist:", error);
    showErrorToast(
      error.response?.data?.message ||
        "Failed to remove from wishlist. Please try again."
    );
    return { success: false };
  }
};
